import type { ColumnDef } from '@ovComponents/2-component/dataTable';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { AggregateExposure } from '../types';
import { getPhantomColumns } from '../utils/phantomColumns';

export function useTickerColumns(): ColumnDef<AggregateExposure, unknown>[] {
  const { t } = useTranslation('portfolioTradingHub');

  return useMemo(
    (): ColumnDef<AggregateExposure, unknown>[] => [
      ...getPhantomColumns<AggregateExposure>({ withExpand: true }),
      {
        id: 'security',
        header: t('tickerView.columns.security'),
        accessorFn: (row) => row.ticker,
      },
      {
        id: 'totalValue',
        header: t('tickerView.columns.totalValue'),
        accessorFn: (row) => row.totalValueCents,
        meta: { dataTable: { align: 'right', numeric: true } },
      },
      {
        id: 'totalQty',
        header: t('tickerView.columns.totalQty'),
        accessorFn: (row) => row.totalQuantity,
        meta: { dataTable: { align: 'right', numeric: true } },
      },
      {
        id: 'portfolios',
        header: t('tickerView.columns.portfolios'),
        accessorFn: (row) => row.portfolioCount,
        meta: { dataTable: { align: 'center' } },
      },
      {
        id: 'pctAum',
        header: t('tickerView.columns.pctAum'),
        accessorFn: (row) => row.percentOfTotalAum,
        meta: { dataTable: { align: 'right', numeric: true } },
      },
      {
        id: 'currency',
        header: t('tickerView.columns.currency'),
        accessorFn: (row) => row.currency,
        meta: { dataTable: { align: 'right' } },
      },
    ],
    [t],
  );
}
